import script from "./CameraPanelUI.vue?vue&type=script&setup=true&lang=ts"
export * from "./CameraPanelUI.vue?vue&type=script&setup=true&lang=ts"

import "./CameraPanelUI.vue?vue&type=style&index=0&id=3c4bbe34&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c4bbe34"]])

export default __exports__